import axios from 'axios';
import { server } from '../host';

export const createProduct = async (product, authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/product`,product, {  
        headers:{ 
            authtoken:authtoken
        }
    });
}

export const getProductsByCount = async (count) => 
    await axios.get( `${server}/api/products/${count}`);



export const getMark = async () => 
    await axios.get( `${server}/api/markup`);
    


export const getDelivery = async () => 
    await axios.get( `${server}/api/delivery`);



export const getProductsByComp = async (company) => {
    return await axios.post(`${server}/api/productByCompany`, {company:company});
}



export const removeProduct = async (slug, authtoken)=>
    await axios.delete( `${server}/api/product/company/${slug}`,{
        headers:{ 
            authtoken,
        }
    })


export const getProduct = async (slug) => 
    await axios.get( `${server}/api/product/${slug}`);


export const updateProduct = async (slug,product, authtoken) =>{  
        //sending in the headers not body
        return await axios.put( `${server}/api/product/company/${slug}`,product, {  
            headers:{ 
                authtoken:authtoken
            }
        });
}



//changes after oct 9


export const getProducts = async (sort, order, page) =>{  
    return await axios.post( `${server}/api/products`,{
        sort:sort,
        //if the values are the same you can send it like below
        order:order,
        page,
    });
}


export const getproductsCount = async () =>{  
    return await axios.get( `${server}/api/products/total`);
}





export const productStar = async (productId , star , review , authtoken) => {
  //sending in the headers not body
  return await axios.put(
    `${server}/api/product/star/${productId}`,
    {
      star,
      review,
    },
    {
      headers: {
        authtoken: authtoken,
      },
    }
  );
};


export const getRelated = async (productId) =>
  await axios.get(`${server}/api/product/related/${productId}`);

export const getSlugRelated = async (slug) =>
  await axios.get(`${server}/api/product/relate/${slug}`);

export const fetchProductsByFilter = async (arg) =>
  await axios.post(`${server}/api/search/filter`, arg);

export const ratingsPagination = async (page, productId) =>
  await axios.post(`${server}/api/ratings/${productId}`, { page });


export const fetchSubProductsByFilter = async (arg, slug) =>
  await axios.post(`${server}/api/search/subs/filter`, {arg, slug});
 